<template>
  <p class="level-label">
    {{ $t("components.CalcLevel.title") }}
  </p>
  <v-btn-toggle
    v-model="value"
    class="text-center"
    density="compact"
    mandatory
    shaped>
    <v-btn
      :value="1"
      class="font-weight-bold"
      selected-class="selected-button"
      size="small">
      I
    </v-btn>
    <v-btn
      :disabled="level < 2"
      :value="2"
      class="font-weight-bold"
      selected-class="selected-button"
      size="small">
      II
    </v-btn>
    <v-btn
      :disabled="level < 3"
      :value="3"
      class="font-weight-bold"
      selected-class="selected-button"
      size="small">
      III
    </v-btn>
  </v-btn-toggle>
</template>

<script setup>
import { computed } from "vue";
import { useSpaceStore } from "@/stores/spaceStore";
import { useCalculationStore } from "../../stores/calculationStore";

const spaceStore = useSpaceStore();
const calculationStore = useCalculationStore();

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  },
  level: {
    type: Number,
    default: 1
  }
});

const value = computed({
  get() {
    return spaceStore.calculationElements?.[props.nodeId]?.level || 0;
  },
  set(newValue) {
    if (spaceStore.readOnly) {
      return;
    }
    calculationStore.changeLevel(props.nodeId, newValue);
  }
});
</script>

<style scoped>
.selected-button {
  background-color: #caddf9;
}

.level-label {
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 6px;
  font-size: smaller;
  padding-bottom: 3px;
}
</style>
